
<script setup>
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/userStore'
import {getKefuAPI} from '@/apis/user'
import md5 from 'js-md5';
import { Base64 } from 'js-base64';
const router = useRouter()

const userStore = useUserStore()
console.log(userStore.userInfo.nickname)
const goBack = () => {
    router.go(-1);
}
let value=userStore.userInfo.id
let id=value.toString()
const userId=md5(id).toString()
const goclose = () => {
    userStore.serviceStatus=false
}
onBeforeUnmount(() => {
    userStore.serviceStatus=false
    });
const messageData=ref()
onMounted(() => {
   
    nextTick(()=>{
        getKefu()
    })
     let data={
        visitorName:userStore.userInfo.nickname,
        visitorAvatar:userStore.userInfo.avatar
    }
    messageData.value=JSON.stringify(data)


})
const serviceUrl=ref()
const getKefu=async ()=>{
    const res = await getKefuAPI()
    if(res.code==0){
        serviceUrl.value =res.data.url
    }
}
console.log('id',userId)
console.log('messageData',messageData)

</script>
<template>
    <div class="service">
     <div class="top">
        <div class="phone" @click="goBack()"><svg-icon icon-class="fanhui" style="width: 2em;height: 2em;"/></div>
        <div></div>
        <div @click="goclose()" class="pc"><svg-icon icon-class="close" style="width: 2em;height: 2em;"/></div>
     </div>
        <iframe 
        v-if="serviceUrl"
        :src="`${serviceUrl}&user_id=${userId}&userinfo=${messageData}`" 
        width="100%" 
        class="iframeClass"
        frameborder="0" 
        allowfullscreen>
        </iframe>
    </div>
</template>
<style scoped lang="scss">
.pc{
    display: block;
}
.phone{
    display: none;
}
.service{
    position: fixed;
    bottom: 0;
    right: 83px;
    background-color: rgb(238, 20, 20);
    padding: 10px;
    z-index: 999;
    width: 600px;
    background: #fff;
    padding: 8px;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, .1);
    border-radius: 8px;
    .top{
        display: flex;
        justify-content: flex-end;
    }
    .iframeClass{
        height: 500px;
    }
}

@media (max-width: 768px) {
    .pc{
    display: none;
    }
    .phone{
        display: block;
    }
    .service{
        height: 100vh !important;
        width: 100%;
        position: static;
       
        padding: 10px;
        z-index: 999;
      
        background: #fff;
        padding: 8px;
        box-shadow: 0 0 10px 1px rgba(0, 0, 0, .1);
        border-radius: 8px;
        .top{
            display: flex;
            justify-content: flex-start; 
        }
        .iframeClass{
            height: 95%;
        }
    }
}
</style>
